import { format } from 'date-fns';
import type { FC } from 'react';
import slugify from 'slugify';
import { Anchors } from '@/components/hub/types';
import { useScrollToElementId } from '@/hooks/useScrollTo.hook';
import type { Bookmaker } from '@/types/bookmaker';
import { getMenuTopOffset } from '@/utils/headerOffset';
import { Button } from '../button';

type NavigationAnchorsProps = {
  data: Bookmaker;
};

const TITLE_OFFSET = 15;

export const NavigationAnchors: FC<NavigationAnchorsProps> = ({ data }) => {
  const scrollToElementId = useScrollToElementId();
  const { updatedAt } = data.attributes;

  const anchors = Object.entries(Anchors).map(([key, title]) => {
    const id = slugify(key, {
      lower: true,
      strict: true,
    });
    return {
      id,
      title,
    };
  });

  const scrollToAnchor = (anchorId: string) => {
    const menuOffset = getMenuTopOffset();
    scrollToElementId(anchorId, {
      offset: menuOffset + TITLE_OFFSET,
      behavior: 'instant',
    });
  };

  return (
    <div className="flex flex-row items-center justify-between pt-4">
      <div className="flex flex-row flex-wrap gap-1">
        {anchors.map((anchor) => (
          <Button
            className="underline"
            key={anchor.id}
            onClick={() => scrollToAnchor(anchor.id)}
            variant="ghost"
          >
            {anchor.title}
          </Button>
        ))}
      </div>
      <time className="text-gray text-sm" dateTime={updatedAt}>
        Last update: {format(updatedAt, 'dd.MM.yyyy')}
      </time>
    </div>
  );
};
